import { useEffect, useRef } from "react";
import Player from "@vimeo/player";
import { track, trackOncePerSession } from "../lib/tracking";

export const VimeoPlayer = ({ videoId, hash, label, testId, onMilestone }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!iframeRef.current) return;
    const player = new Player(iframeRef.current);
    const posKey = `pv_video_pos_${videoId}`;
    let lastSave = 0;

    const saved = parseFloat(localStorage.getItem(posKey) || "0");
    if (saved > 3) {
      player.setCurrentTime(saved).catch(() => {});
    }

    const onPlay = () => trackOncePerSession(`pv_play_${videoId}`, `${label}Play`, { video: label });

    const onTimeUpdate = ({ seconds, percent }) => {
      if (seconds - lastSave > 2) {
        lastSave = seconds;
        localStorage.setItem(posKey, String(seconds));
      }
      [15, 50, 90].forEach((m) => {
        const k = `pv_ms_${videoId}_${m}`;
        if (percent * 100 >= m && !localStorage.getItem(k)) {
          localStorage.setItem(k, "1");
          track(`${label}Watched${m}`, { video: label, percent: m });
          if (onMilestone) onMilestone(m);
        }
      });
    };

    const onEnded = () => localStorage.removeItem(posKey);

    player.on("play", onPlay);
    player.on("timeupdate", onTimeUpdate);
    player.on("ended", onEnded);

    return () => {
      player.off("play", onPlay);
      player.off("timeupdate", onTimeUpdate);
      player.off("ended", onEnded);
    };
  }, [videoId, label]);

  return (
    <div className="pv-video-frame" data-testid={testId}>
      <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
        <iframe
          ref={iframeRef}
          src={`https://player.vimeo.com/video/${videoId}?${hash ? `h=${hash}&` : ""}title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
          title={label}
        />
      </div>
    </div>
  );
};
